import React from 'react';
import {
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  Receipt as ReceiptIcon,
  LocalAtm as LocalAtmIcon,
  AttachMoney as AttachMoneyIcon,
  Payment as PaymentIcon,
  AccountBalance as AccountBalanceIcon
} from '@mui/icons-material';
import api from '../../services/api';

// مكون قائمة السندات المتخصصة الديناميكية
// هذا المكون سيتم استدعاؤه من SidebarMenu.tsx
export const getSpecializedVoucherMenuItems = async () => {
  try {
    // استخدام خدمة API لجلب قوالب السندات المتخصصة
    const response = await api.get('/finance/specialized-vouchers/templates');
    
    if (!Array.isArray(response.data)) {
      console.error('تنسيق غير متوقع للبيانات المسترجعة:', response.data);
      return [];
    }
    
    return response.data.map(template => ({
      id: template._id,
      to: `/finance/specialized-vouchers/template/${template._id}`,
      icon: getIconForVoucherType(template.type || 'default'),
      text: template.name || getArabicNameForType(template.type || 'default'),
      permissionCheck: {
        section: 'finance',
        page: `voucher-${template._id}`,
        action: 'view_page'
      }
    }));
  } catch (err) {
    console.error('خطأ في تحميل قوالب السندات المتخصصة:', err);
    return [];
  }
};

// اختيار الأيقونة المناسبة لنوع السند
export const getIconForVoucherType = (type: string) => {
  switch (type) {
    case 'receipt_voucher':
      return <ReceiptIcon fontSize="small" />;
    case 'payment_voucher':
      return <PaymentIcon fontSize="small" />;
    case 'fee_voucher':
      return <LocalAtmIcon fontSize="small" />;
    case 'financial_voucher':
      return <AttachMoneyIcon fontSize="small" />;
    case 'bank_voucher':
      return <AccountBalanceIcon fontSize="small" />;
    default:
      return <AssignmentTurnedInIcon fontSize="small" />;
  }
};

// الحصول على اسم عربي لنوع السند
export const getArabicNameForType = (type: string) => {
  switch (type) {
    case 'receipt_voucher':
      return 'سند قبض';
    case 'payment_voucher':
      return 'سند صرف';
    case 'fee_voucher':
      return 'سند رسوم';
    case 'financial_voucher':
      return 'سند مالي';
    case 'bank_voucher':
      return 'سند بنكي';
    default:
      return type;
  }
};